import appPackage from '../package.json';
import changelogSource from '../../../CHANGELOG.md?raw';

export interface ChangelogRelease {
  title: string;
  changes: string[];
}

export const APP_VERSION = appPackage.version;

export function parseChangelog(source: string): ChangelogRelease[] {
  const releases: ChangelogRelease[] = [];
  let current: ChangelogRelease | null = null;

  for (const line of source.split(/\r?\n/)) {
    if (line.startsWith('## ')) {
      current = { title: line.slice(3).trim(), changes: [] };
      releases.push(current);
    } else if (current && line.startsWith('- ')) {
      current.changes.push(line.slice(2).trim());
    }
  }

  return releases;
}

export const CHANGELOG = parseChangelog(changelogSource);
